export default __webpack_public_path__ + "static/media/smart.bca4cd32.png";